export class ContentType {
    id: number;
    name: string;
}
